import {
  expiringConsignmentImages,
  newConsignmentImages,
} from 'static/images/notification';

export enum Template {
  consignmentAvailable = 'consignmentAvailable',
  consignmentExpiring = 'consignmentExpiring',
  multiConsignmentAvailable = 'multiConsignmentAvailable',
}

interface NotificationTemplate {
  title: string;
  config: {
    body: string;
    image: string;
    icon: string;
  };
}

export interface TemplateOptions {
  consignmentQuantity?: number;
  consignmentExpireHour?: string;
  consignmentCode?: string;
}

const notificationTemplates: {
  [key in Template]: (options?: TemplateOptions) => NotificationTemplate;
} = {
  consignmentAvailable: () => ({
    title: 'Retire e Entrega',
    config: {
      body: 'Você possui um pedido disponível para atendimento!',
      image: newConsignmentImages.banner,
      icon: newConsignmentImages.icon,
    },
  }),
  consignmentExpiring: (options?: TemplateOptions) => ({
    title: 'Retire e Entrega',
    config: {
      body: `O pedido ${options?.consignmentCode} expirará em 1 hora!`,
      image: expiringConsignmentImages.banner,
      icon: expiringConsignmentImages.icon,
    },
  }),
  multiConsignmentAvailable: (options?: TemplateOptions) => ({
    title: 'Retire e Entrega',
    config: {
      body: `Há ${options?.consignmentQuantity} novos pedidos disponíveis. Um deles expirará em ${options?.consignmentExpireHour}!`,
      image: newConsignmentImages.banner,
      icon: newConsignmentImages.icon,
    },
  }),
};

export function getContent(
  template: Template,
  options?: TemplateOptions
): NotificationTemplate {
  const { title, config } = notificationTemplates[template](options);

  return { title, config };
}
